module.exports = __webpack_public_path__ + "static/media/icon-integracao-sasc.88d5de19.png";